import { RoutePath } from "#src/utils/route";
import { DataToolsRoutePath } from "..";

export const RunLogRoutePath = DataToolsRoutePath.concat(
  new RoutePath<"job_id">({
    path: "/run-log",
    title: "Run Log",
  })
);
